export const BASE_API_URL = "/insurance/healthdeclarations.v2";
export const BASE_BENEFICIARY_API_URL = "/insurance/beneficiary";
export const DOCUMENT_HANDLER_API_URL = "/shared/documents";
export const LEVEL_4_ACR = "https://id.storebrand.no/authn/al4";
